import { actions, types } from './requests'
export const GETINTERVALLIST_TYPES = {
    ...types('GETINTERVALLIST'),
}
export const GETINTERVALLIST_ACTIONS = {
    ...actions('GETINTERVALLIST'),
}